import React, { useState, createContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./index.css";

// Components
import BottomNav from "./Components/BottomNav";
import InstallButton from "./Components/InstallButton";
import PosterTemplate from "./Components/PosterTemplate";
import TopBar from "./Components/TopBar";
import EditField from "./Components/EditField";
import MainLayout from "./Layouts/MainLayout";
import Header from "./Components/Header";






// Extra pages
import Groups from "./pages/Groups";
import MarketCards from "./pages/MarketCards";
import DepositTzMobile from "./pages/DepositTzMobile";
import MobilePayment from "./pages/MobilePayment";
import AllDepositCountry from "./pages/AllDepositCountry";
import Earning from "./pages/Earning";
import WeeklyDepositBonusUSDT from "./pages/WeeklyDepositBonusUSDT";
import LeagueMatches from "./pages/LeagueMatches";





// User pages
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import MyPage from "./pages/MyPage";
import AneyBonus from "./pages/AneyBonus";
import TradeList from "./pages/TradeList";
import History from "./pages/History";
import Menu from "./pages/Menu";
import UserRefunds from "./pages/UserRefunds";
import Monthly from "./pages/Monthly";
import Team from "./pages/Team";
import About from "./pages/About";
import EventList from "./pages/EventList";
import InviteCode from "./pages/InviteCode";
import AgentIntro from "./pages/AgentIntro";
import RuleDescription from "./pages/RuleDescription";
import Translator from "./pages/Translator";
import UserFidiaList from "./pages/UserFidiaList";
import NewRegister from "./pages/NewRegister";
import NewWithdrawals from "./pages/NewWithdrawals";
import PromotionsPage from "./pages/PromotionsPage";
import FirstDepositBonus from "./pages/FirstDepositBonus";
import SecondDepositBonus from "./pages/SecondDepositBonus";
import FirstDepositBonusUSDT from "./pages/FirstDepositBonusUSDT";
import SecondDepositBonusUSDT from "./pages/SecondDepositBonusUSDT";
import WeeklyDepositBonus from "./pages/WeeklyDepositBonus";
import UsersGroup from "./pages/UsersGroup";
import UsdtManagement from "./pages/UsdtManagement";
import CustomerCare from "./pages/CustomerCare";
import UserGain from "./pages/UserGain";
import Settings from "./pages/Settings";
import Agents from "./pages/Agents";
import AdminTafutagamesyauser from "./pages/AdminTafutagamesyauser";
import AdminBetsWrongPay from "./pages/AdminBetsWrongPay";
import AdminEdiotTransaction from "./pages/AdminEdiotTransaction";


import  AdminBonusManager from "./pages/AdminBonusManager";

import Deposit from "./pages/Deposit";
import TradingView from "./pages/TradingView";
import ConfirmOrder from "./pages/ConfirmOrder";
import MarketChart from "./pages/MarketChart";

import Withdraw from "./pages/Withdraw";
import Register from "./pages/Register";
import Info from "./pages/Info";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Assets from "./pages/Assets";
import Rules from "./pages/Rules";
import Football from "./pages/Football";
import Crypto from "./pages/Crypto";
import Forex from "./pages/Forex";
import Cricket from "./pages/Cricket";
import Baseball from "./pages/Baseball";
import Basketball from "./pages/Basketball";
import SymbolForex from "./pages/SymbolForex";
import LeagueTabs from "./pages/LeagueTabs";
import AllPages from "./pages/AllPages";
import ConfirmDeposits from "./pages/ConfirmDeposits";
import CountrySelector from "./pages/CountrySelector";
import CryptoWallets from "./pages/CryptoWallets";
import WithdrawByUsdt from "./pages/WithdrawByUsdt";
import DepositCrypto from "./pages/DepositCrypto";
import CryptoWallet from "./pages/CryptoWallet";


import Market from "./pages/Market";
import Trader from "./pages/Trader";
import Volume from "./pages/Volume";
import Signal from "./pages/Signal";
import Sports from "./pages/Sports";
import BetPlace from "./pages/BetPlace";
import DepositMobile from "./pages/DepositMobile";
import EastWallet from "./pages/EastWallet";
import BonusHistory from "./pages/BonusHistory";
import Gift from "./pages/Gift";
import UserMonthlyBonusHistory from "./pages/UserMonthlyBonusHistory";
import AdminAddBasketball from "./pages/AdminAddBasketball";
import AdminOtherBetAntScore from "./pages/AdminOtherBetAntScore";
import CopyTradingConfirmedOrder from "./pages/CopyTradingConfirmedOrder";
import OtherBetHistory from "./pages/OtherBetHistory";


import ExchangeMoney from "./pages/ExchangeMoney";
import AddCard from "./pages/AddCard";
import GrowthPlan from "./pages/GrowthPlan";
import Wallets from "./pages/Wallets";



import Trade from "./pages/Trade";
import Bulk from "./pages/Bulk";
import Bots from "./pages/Bots";
import Cashier from "./pages/Cashier";
import Developers from "./pages/Developers";

import Account from "./pages/Account";

import Recorder from "./pages/Recorder";




import DepisitBFCOrder from "./pages/DepisitBFCOrder";
import MyTransactions from "./pages/MyTransactions";
import NewDeposit from "./pages/NewDeposit";
import TotalGain from "./pages/TotalGain";
import Records from "./pages/Records";
import Record from "./pages/Record";
import ParcenalCenter from "./pages/ParcenalCenter";
import Announcement from "./pages/Announcement";
import MatchList from "./pages/MatchList";
import GamesResult from "./pages/GamesResult";
import Report from "./pages/Report";
import Logout from "./pages/Logout";
import VolatilityClosed from "./pages/VolatilityClosed";
import VolatilityOpen from "./pages/VolatilityOpen";
import TradeDetails from "./pages/TradeDetails";
import ForexHistory from "./pages/ForexHistory";
import Chart from "./pages/Chart";
import Messages from "./pages/Messages";
import CryptoTradingViewChart from "./pages/CryptoTradingViewChart";
import AdminViewWithdrawHistory from "./pages/AdminViewWithdrawHistory";





import AdminAddTabletennes from "./pages/AdminAddTabletennes";

import TableTennis from "./pages/TableTennis";
import AdminAddIceHockey from "./pages/AdminAddIceHockey";
import AdminAddBaseball from "./pages/AdminAddBaseball";

// Admin pages
import AdminDashboard from "./pages/AdminDashboard";
import AddMatch from "./pages/AddMatch";
import Notifications from "./pages/Notifications";
import Commission from "./pages/Commission";

import AdminUserBonus from "./pages/AdminUserBonus";
import AgentRoute from "./routes/AgentRoute";
import AgentDashboard from "./pages/AgentDashboard";
import AgentAddMatches from "./pages/AgentAddMatches";
import AgentSearchUser from "./pages/AgentSearchUser";
import AdminUsers from "./pages/AdminUsers";
import BonusMember from "./pages/BonusMember";
import AgentPending from "./pages/AgentPending";
import OtherBetPlace from "./pages/OtherBetPlace";
import AdminForexTracking from "./pages/AdminForexTracking";
import CopyTrading from "./pages/CopyTrading";
import LanguageSelector from "./Components/LanguageSelector";



import AdminSecurityWithdraw from "./pages/AdminSecurityWithdraw";
import AdminTransactions from "./pages/AdminTransactions";
import AdminBetsPayoutLost from "./pages/AdminBetsPayoutLost";
import EditMatch from "./pages/EditMatch";
import BetTrade from "./pages/BetTrade";
import AdminVistorDeposit from "./pages/AdminVistorDeposit";
import OtherCountryConfirmed from "./pages/OtherCountryConfirmed";
import WithdrawRecord from "./pages/WithdrawRecord";
import ConfirmedWithdraw from "./pages/ConfirmedWithdraw";
import WithdrawRecords from "./pages/WithdrawRecords";
import ChangePassword from "./pages/ChangePassword";
import UserCommissionRecord from "./pages/UserCommissionRecord";
import AdminMonthlyBonus from "./pages/AdminMonthlyBonus";
import AdminNotifications from "./pages/AdminNotifications";
import AdminGenerationMatches from "./pages/AdminGenerationMatches";

import AdminViewBetHistory from "./pages/AdminViewBetHistory";
import BfcMobilePaymentcrypto from "./pages/BfcMobilePaymentcrypto";
import BfcCryptoWallet from "./pages/BfcCryptoWallet";
import AdminVolatilityForexTransaction from "./pages/AdminVolatilityForexTransaction";
import BFCOtherCountryConfirmed from "./pages/BFCOtherCountryConfirmed";
import ManualTrade from "./pages/ManualTrade"
import AdminVolatility from "./pages/AdminVolatility";
import Tennis from "./pages/Tennis";
import IceHockey from "./pages/IceHockey";
import OtherBetScore from "./pages/OtherBetScore";
import AdminOtherBetCorrectScore from "./pages/AdminOtherBetCorrectScore";
import AdminAddCopyTrading from "./pages/AdminAddCopyTrading";
import AdminCopyTradingRequest from "./pages/AdminCopyTradingRequest";
import MyCopyTradeRecords from "./pages/MyCopyTradeRecords";
import ChangeLanguage from "./pages/ChangeLanguage";



import AdminDuplicateMatches from "./pages/AdminDuplicateMatches";
import AgentDuplicateMatches from "./pages/AgentDuplicateMatches";
import AdminMatchManager from "./pages/AdminMatchManager";
import AdminHistoriayadau from "./pages/AdminHistoriayadau";
import AdminManageNumbers from "./pages/AdminManageNumbers";
import AdminCommissions from "./pages/AdminCommissions";
import AdminBetsRequest from "./pages/AdminBetsRequest";
import AdminAddFinalScore from "./pages/AdminAddFinalScore";
import AdminBalanceControl from "./pages/AdminBalanceControl";
import Adminchekibonus from "./pages/Adminchekibonus";
import AgentHistoriayadau from "./pages/AgentHistoriayadau";
import AdminHackingMatches from "./pages/AdminHackingMatches";
import AdimnViewEndedMatches from "./pages/AdimnViewEndedMatches";
import Adminfutagroup from "./pages/Adminfutagroup";
import DepositExpress from "./pages/DepositExpress";

import DepositRecord from "./pages/DepositRecord";
import EarningRecord from "./pages/EarningRecord";
import LiveChatPage from "./pages/LiveChatPage";
import AdminUsdtTransaction from "./pages/AdminUsdtTransaction";
import AllAddMatchesFilter from "./pages/AllAddMatchesFilter";
import AdminBetCorrectScore from "./pages/AdminBetCorrectScore";
import Volatility from "./pages/Volatility";
import BfcMobilePayment from "./pages/BfcMobilePayment";
import BfcConfirmDeposit from "./pages/BfcConfirmDeposit";
import AutoTrade from "./pages/AutoTrade";
import VolatilityHistory from "./pages/VolatilityHistory";
import AdminAddTennis from "./pages/AdminAddTennis";

import AdminCommissionHistory from "./pages/AdminCommissionHistory";
import AdminDeletedWithdrawHistory from "./pages/AdminDeletedWithdrawHistory";
import FutaMaombiYaUondoaji from "./pages/FutaMaombiYaUondoaji";
import AdminTeamProfitSearch from "./pages/AdminTeamProfitSearch";

import AdminSearchUser from "./pages/AdminSearchUser";
import PendingWithdrawals from "./pages/PendingWithdrawals";
import AdminUserSearch from "./pages/AdminUserSearch";
import AdminUsersMember from "./pages/AdminUsersMember";
import AdminExchanges from "./pages/AdminExchanges";
import AdminEnterMatches from "./pages/AdminEnterMatches";
import BetScores from "./pages/Betscores";
import { BalanceProvider } from "./context/BalanceContext";

import AdminBadilishaMudaWaMatches from "./pages/AdminBadilishaMudaWaMatches";



// Routes (guards)
import AdminRoute from "./routes/AdminRoute";
import PrivateRoute from "./routes/PrivateRoute";

// Create context
export const LanguageContext = createContext();

const LayoutWithBottomNav = ({ children }) => {
  const location = useLocation();

  const hideOnRoutes = [
    "/login",
    "/register",
    "/rules",
    "/auto-trade",
    "/Recorder",
    "/developers",
    "/Withdraw",
    "/bulk",
    "/crypto",
  
    "/betscores/:id",
    "/trade-details/",
    "/charts",
    "/admin-matchmanager",
    "/messages",
    "/Crypto-Wallets",
    "/signal",
    "/change-language",
    "/Admin-AddFinalScore",
    "/admin-managenumbers",
    "/my-copy-trading-records",
    "/copy-trading",
    "/copy-trading/confirmed-order",
    "/Admin-Add-Copy-Trading",
    "/copy-trading/confirmed-order",
    "/Copy-Trading",
    "/admin-usersearch",
    "/Forex-History",
    "/confirm-order",
    "/tradingview",
    "/history",
    "/Admin-Forex-Tracking",
    "/AdminOther-BetAntScore",
    "/admin-betsrequest",
    "/AdminOther-BetCorrectScore",
    "/All-AddMatches-Filter",
    "/Admin-Usdt-Transaction",
    "/admin-volatility",
    "/volatility-closed",
  "/volatility-open", 
    "/volatility-history",
    "/BFCConfirm-deposit",  
    "/bfc-mobile-payment",
    "/admin-dashboard", 
    "/all-pages",
    "/trader",
    "/trade/",
    "/language-selector",
    "/trade/:id",
    "/volatility",
    "/abouts",
    "/forex", 
    "/info",
  ];

  const hideHeaderRoutes = [
    "/signal",
   
    "/volume",
    "/forex",
    "/trade/:id",
    "/DepisitBFCOrder",
    "/assets",
    "/trader",
    "/trade",
    "/BfcCryptoWallet",
    "/BfcMobilePaymentcrypto",
    "/other-country-confirmed",
    "/profile",
    "/FirstDepositBonus",
    "/SecondDepositBonus",
    "/WeeklyDepositBonus",
    "/withdraw",
    "/Confirmed-Withdraw",
    "/Bonus-History",
    "/settings",
    "/gift",
    "/user-commission-record",
    "/change-Password",
    "/report",
    "/record",
    "/deposit/crypto",
    "/support/chat",
    "/customer-care",
    "/customer-cares",
    "/totalgain",

    "/userrefunds",
    "/invitecode",
    "/newdeposit",
    "/crypto-wallet",
    "/UserMonthly-BonusHistory",
    "/mobile-payment",
    "/deposittzmobile",
    "/confirm-deposits",
    "/newwithdrawals",
    "/team",

   
    "/newregister",
    "/user-gain",
    "/withdraw-by-usdt",
    "/all-pages",
    "/sports",
    "/confirm-order",
    "/tradingview",
    "/dashboard",
  ];


 
const isChartPage = location.pathname.startsWith("/chart/");



const shouldHideBottomNav =
  isChartPage ||
  hideOnRoutes.includes(location.pathname) ||
  location.pathname === "/trader" ||
  location.pathname === "/trade" ||
  location.pathname.startsWith("/trade/");
 



const shouldHideHeader =
  isChartPage ||
  hideOnRoutes.includes(location.pathname) ||
  hideHeaderRoutes.includes(location.pathname) ||
  location.pathname === "/trader" ||
  location.pathname === "/trade" ||
  location.pathname.startsWith("/trade/");

const isVolatility =
  location.pathname === "/volatility";

const isLoggedIn =
  localStorage.getItem("authenticated") === "true";

/* =====================================================
   VOLATILITY
===================================================== */

if (isVolatility) {
  return (
    <main
      className="app-content volatility-host"
      style={{
        padding: 0,
        margin: 0,
      }}
    >
      {children}
    </main>
  );
}

  /* =====================================================
     NORMAL PAGES
     
     IMPORTANT:
     Header yenyewe ndiyo inasimamia nafasi yake.
     HATUONGEZI padding-top ya 65px hapa.
  ===================================================== */

  return (
    <>
      {!shouldHideHeader && isLoggedIn && <Header />}
  
      <main
        className={
          shouldHideHeader
            ? "app-content no-header"
            : "app-content with-header"
        }
        style={{
          paddingTop: "0px",
          paddingRight: "0px",
          paddingLeft: "0px",
          paddingBottom: "0px",
          marginTop: "0px",
        }}
      >
        {children}
      </main>
  
     
{!shouldHideBottomNav && isLoggedIn && <BottomNav />}

{[
  "/login",
  "/register",
  "/assets",
  "/settings",
  "/gift",
].includes(location.pathname.toLowerCase()) && (
  <InstallButton />
)}

    </>
  );
};
const App = () => {
  const [language, setLanguage] = useState("en");

  

  return (






    <LanguageContext.Provider value={{ language, setLanguage }}>
      <BalanceProvider>

        <Router>

    

          <LayoutWithBottomNav>

<Routes>
       {/* ================= PUBLIC ROUTES ================= */}

<Route path="/" element={<Navigate to="/login" replace />} />
<Route path="/login" element={<Login />} />
<Route path="/register" element={<Register />} />
<Route path="/abouts" element={<About />} />
<Route path="/rules" element={<Rules />} />
<Route path="/info" element={<Info />} />
<Route path="/customer-cares" element={<CustomerCare />} />



            
{/* ================= USER ROUTES ================= */}

<Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
<Route path="/about" element={<PrivateRoute><About /></PrivateRoute>} />
<Route path="/table-tennis" element={<PrivateRoute><TableTennis /></PrivateRoute>} />
<Route path="/BfcConfirm-Deposit" element={<PrivateRoute><BfcConfirmDeposit /></PrivateRoute>} />
<Route path="/volatility-history" element={<PrivateRoute><VolatilityHistory /></PrivateRoute>} />
<Route path="/earning" element={<Earning />} />
<Route path="/Forex-History" element={<ForexHistory />} />
<Route path="/messages" element={<Messages />} />

<Route path="/deposit-record" element={<DepositRecord />} />
<Route path="/forex" element={<PrivateRoute><Forex /></PrivateRoute>} />
<Route path="/earning-record" element={<EarningRecord />} />
<Route path="/admin-addtennis" element={<AdminAddTennis />} />
<Route path="/UserMonthly-BonusHistory" element={<UserMonthlyBonusHistory />} />
<Route path="/support/chat" element={<LiveChatPage />} />
<Route path="/volatility-closed" element={<VolatilityClosed />} />
<Route path="/volatility-open" element={<VolatilityOpen />} />
<Route path="/userrefunds" element={<PrivateRoute><UserRefunds /></PrivateRoute>} />
<Route path="/mypage" element={<PrivateRoute><MyPage /></PrivateRoute>} />
<Route path="/other-betplace" element={<PrivateRoute><OtherBetPlace /></PrivateRoute>} />
<Route path="/auto-trade" element={<AutoTrade />} />
<Route path="/tennis" element={<Tennis />} />
<Route path="/manual-trade" element={<PrivateRoute><ManualTrade /></PrivateRoute>} />
<Route path="/assets" element={<PrivateRoute><Assets /></PrivateRoute>} />
<Route path="/DepisitBFCOrder" element={<DepisitBFCOrder />} />
<Route path="/deposit/crypto" element={<PrivateRoute><DepositCrypto /></PrivateRoute>} />
<Route path="/chart/:coin" element={<CryptoTradingViewChart />}/>
<Route path="/Copy-Trading" element={<CopyTrading />}/>
<Route path="/language-selector" element={<LanguageSelector />}/>



<Route path="/league/:leagueName" element={<LeagueMatches />} />
<Route path="/trade" element={<Trade />} />
<Route path="/language-selector" element={<LanguageSelector />} />
<Route path="/change-language" element={<ChangeLanguage />} />




<Route path="/bulk" element={<Bulk />} />
<Route path="/bots" element={<Bots />} />
<Route path="/cashier" element={<Cashier />} />
<Route path="/developers" element={<Developers />} />
<Route path="/history" element={<PrivateRoute><History /></PrivateRoute>} />
<Route path="/account" element={<Account />} />
<Route path="/logout" element={<PrivateRoute><Logout /></PrivateRoute>} />
<Route path="/Recorder" element={<Recorder />} />
<Route path="/gift" element={<PrivateRoute><Gift /></PrivateRoute>} />
<Route path="/crypto-wallet" element={<CryptoWallet />} />
<Route path="/change-Password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
<Route path="/bfc-mobile-payment" element={<PrivateRoute><BfcMobilePayment /></PrivateRoute>} />
<Route path="/Bonus-History" element={<PrivateRoute><BonusHistory /></PrivateRoute>} />
<Route path="/BFCother-country-confirmed" element={<BFCOtherCountryConfirmed />} />
<Route path="/Crypto-Wallets" element={<PrivateRoute><CryptoWallets /></PrivateRoute>} />
<Route path="/withdraw-by-usdt" element={<PrivateRoute><WithdrawByUsdt /></PrivateRoute>} />
<Route path="/East-Wallet" element={<PrivateRoute><EastWallet /></PrivateRoute>} />
<Route path="/deposit/country" element={<PrivateRoute><AllDepositCountry /></PrivateRoute>} />
<Route path="/BfcCryptoWallet" element={<PrivateRoute><BfcCryptoWallet /></PrivateRoute>} />
<Route path="/confirm-deposits" element={<PrivateRoute><ConfirmDeposits /></PrivateRoute>} />
<Route path="/BfcMobilePaymentcrypto" element={<PrivateRoute><BfcMobilePaymentcrypto /></PrivateRoute>} />
<Route path="/mobile-payment" element={<PrivateRoute><MobilePayment /></PrivateRoute>} />
<Route path="/Country-Selector" element={<PrivateRoute><CountrySelector /></PrivateRoute>} />
<Route path="/market-chart/:id" element={<MarketChart />} />
<Route path="/betplace" element={<BetPlace />} />
<Route path="/deposit/mobile" element={<DepositMobile />} />
<Route path="/sports" element={<PrivateRoute><Sports /></PrivateRoute>} />
<Route path="/deposittzmobile" element={<PrivateRoute><DepositTzMobile /></PrivateRoute>} />
<Route path="/Confirmed-Withdraw" element={<PrivateRoute><ConfirmedWithdraw /></PrivateRoute>} />
<Route path="/all-pages" element={<PrivateRoute><AllPages /></PrivateRoute>} />
<Route path="/bet-trade" element={<PrivateRoute><BetTrade /></PrivateRoute>} />
<Route path="/Other-Country-Confirmed" element={<PrivateRoute><OtherCountryConfirmed /></PrivateRoute>} />
<Route path="/Deposit-Express" element={<PrivateRoute><DepositExpress /></PrivateRoute>} />
<Route path="/betscores/:id" element={<PrivateRoute><BetScores /></PrivateRoute>} />
<Route path="/otherbetscore/:id" element={<PrivateRoute><OtherBetScore /></PrivateRoute>} />
<Route path="/trade/:id" element={<Trade />} />
<Route path="/charts" element={<Chart />} />
<Route path="/copy-trading/confirmed-order" element={<CopyTradingConfirmedOrder />} />
<Route path="/my-copy-trading-records" element={<MyCopyTradeRecords />}/>
<Route path="/Other-Bet-History" element={<OtherBetHistory />}/>

<Route
  path="/admin/bet-history"
  element={<AdminViewBetHistory />}
/>




<Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
<Route path="/announcement" element={<PrivateRoute><Announcement /></PrivateRoute>} />
<Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
<Route path="/parcenalcenter" element={<PrivateRoute><ParcenalCenter /></PrivateRoute>} />
<Route path="/league-tabs" element={<PrivateRoute><LeagueTabs /></PrivateRoute>} />
<Route path="/market" element={<PrivateRoute><Market /></PrivateRoute>} />
<Route path="/trader" element={<PrivateRoute><Trader /></PrivateRoute>} />
<Route path="/volume" element={<PrivateRoute><Volume /></PrivateRoute>} />
<Route path="/signal" element={<PrivateRoute><Signal /></PrivateRoute>} />
<Route path="/football" element={<PrivateRoute><Football /></PrivateRoute>} />
<Route path="/crypto" element={<PrivateRoute><Crypto /></PrivateRoute>} />
<Route path="/tradingview" element={<PrivateRoute><TradingView /></PrivateRoute>} />
<Route path="/symbolforex" element={<PrivateRoute><SymbolForex /></PrivateRoute>} />
<Route path="/cricket" element={<PrivateRoute><Cricket /></PrivateRoute>} />
<Route path="/confirm-order" element={<PrivateRoute><ConfirmOrder /></PrivateRoute>} />
<Route path="/baseball" element={<PrivateRoute><Baseball /></PrivateRoute>} />
<Route path="/basketball" element={<PrivateRoute><Basketball /></PrivateRoute>} />
<Route path="/ruledescription" element={<PrivateRoute><RuleDescription /></PrivateRoute>} />
<Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
<Route path="/marketcards" element={<PrivateRoute><MarketCards /></PrivateRoute>} />
<Route path="/aneybonus" element={<PrivateRoute><AneyBonus /></PrivateRoute>} />
<Route path="/Growth-Plan" element={<PrivateRoute><GrowthPlan /></PrivateRoute>} />
<Route path="/Weekly/Deposit/BonusUSDT" element={<PrivateRoute><WeeklyDepositBonusUSDT /></PrivateRoute>} />
<Route path="/volatility" element={<PrivateRoute><Volatility /></PrivateRoute>} />
<Route path="/monthly" element={<PrivateRoute><Monthly /></PrivateRoute>} />
<Route path="/invitecode" element={<PrivateRoute><InviteCode /></PrivateRoute>} />
<Route path="/menu" element={<PrivateRoute><Menu /></PrivateRoute>} />
<Route path="/eventlist" element={<PrivateRoute><EventList /></PrivateRoute>} />
<Route path="/tradelist" element={<PrivateRoute><TradeList /></PrivateRoute>} />
<Route path="/edit-field" element={<PrivateRoute><EditField /></PrivateRoute>} />
<Route path="/games-result" element={<PrivateRoute><GamesResult /></PrivateRoute>} />
<Route path="/withdraw-records" element={<PrivateRoute><WithdrawRecords /></PrivateRoute>} />
<Route path="/report" element={<PrivateRoute><Report /></PrivateRoute>} />
<Route path="/user-gain" element={<PrivateRoute><UserGain /></PrivateRoute>} />
<Route path="/totalgain" element={<PrivateRoute><TotalGain /></PrivateRoute>} />
<Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
<Route path="/agents" element={<PrivateRoute><Agents /></PrivateRoute>} />
<Route path="/wallets" element={<PrivateRoute><Wallets /></PrivateRoute>} />
<Route path="/TopBar" element={<PrivateRoute><TopBar /></PrivateRoute>} />
<Route path="/deposit" element={<PrivateRoute><Deposit /></PrivateRoute>} />
<Route path="/withdraw" element={<PrivateRoute><Withdraw /></PrivateRoute>} />
<Route path="/team" element={<PrivateRoute><Team /></PrivateRoute>} />
<Route path="/commission" element={<PrivateRoute><Commission /></PrivateRoute>} />
<Route path="/agent-intro" element={<PrivateRoute><AgentIntro /></PrivateRoute>} />
<Route path="/add-card" element={<PrivateRoute><AddCard /></PrivateRoute>} />
<Route path="/exchange-money" element={<PrivateRoute><ExchangeMoney /></PrivateRoute>} />
<Route path="/records" element={<PrivateRoute><Records /></PrivateRoute>} />
<Route path="/record" element={<PrivateRoute><Record /></PrivateRoute>} />
<Route path="/withdraw-record" element={<PrivateRoute><WithdrawRecord /></PrivateRoute>} />
<Route path="/user-commission-record" element={<PrivateRoute><UserCommissionRecord /></PrivateRoute>} />
<Route path="/NewRegister" element={<PrivateRoute><NewRegister /></PrivateRoute>} />
<Route path="/MyTransactions" element={<PrivateRoute><MyTransactions /></PrivateRoute>} />
<Route path="/newdeposit" element={<PrivateRoute><NewDeposit /></PrivateRoute>} />
<Route path="/groups" element={<PrivateRoute><Groups /></PrivateRoute>} />
<Route path="/newwithdrawals" element={<PrivateRoute><NewWithdrawals /></PrivateRoute>} />
<Route path="/PromotionsPage" element={<PrivateRoute><PromotionsPage /></PrivateRoute>} />
<Route path="/FirstDepositBonus" element={<PrivateRoute><FirstDepositBonus /></PrivateRoute>} />
<Route path="/SecondDepositBonus" element={<PrivateRoute><SecondDepositBonus /></PrivateRoute>} />
<Route path="/FirstDepositBonusUSDT" element={<PrivateRoute><FirstDepositBonusUSDT /></PrivateRoute>} />
<Route path="/SecondDepositBonusUSDT" element={<PrivateRoute><SecondDepositBonusUSDT /></PrivateRoute>} />
<Route path="/WeeklyDepositBonus" element={<PrivateRoute><WeeklyDepositBonus /></PrivateRoute>} />
<Route path="/usdt-management" element={<PrivateRoute><UsdtManagement /></PrivateRoute>} />
<Route path="/customer-care" element={<PrivateRoute><CustomerCare /></PrivateRoute>} />
<Route path="/UserFidiaList" element={<PrivateRoute><UserFidiaList /></PrivateRoute>} />
<Route path="/matchlist" element={<PrivateRoute><MatchList /></PrivateRoute>} />
<Route path="/translator" element={<PrivateRoute><Translator /></PrivateRoute>} />
<Route path="/icehockey" element={<IceHockey />} />
<Route
  path="/usersgroup"
  element={
    <PrivateRoute>
      <UsersGroup />
    </PrivateRoute>
  }
/>


{/* ================= ADMIN ROUTES ================= */}

<Route path="/admin-dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
<Route path="/admin-userbonus" element={<AdminRoute><AdminUserBonus /></AdminRoute>} />
<Route path="/AdminOther-BetCorrectScore" element={<AdminRoute><AdminOtherBetCorrectScore /></AdminRoute>} />
<Route path="/Adimn-View-Ended-Matches" element={<AdminRoute><AdimnViewEndedMatches /></AdminRoute>} />
<Route path="/admin-bets-wrong-pay" element={<AdminRoute><AdminBetsWrongPay /></AdminRoute>} />
<Route path="/admin-BetCorectScore" element={<AdminRoute><AdminBetCorrectScore /></AdminRoute>} />
<Route path="/All-AddMatches-Filter" element={<AdminRoute><AllAddMatchesFilter /></AdminRoute>} />
<Route path="/AdminOther-BetAntScore" element={<AdminRoute><AdminOtherBetAntScore /></AdminRoute>} />
<Route path="/admin-tafutagamesyauser" element={<AdminRoute><AdminTafutagamesyauser /></AdminRoute>} />
<Route path="/EnterMatches" element={<AdminRoute><AdminEnterMatches /></AdminRoute>} />
<Route path="/Admin-TeamProfitSearch" element={<AdminRoute><AdminTeamProfitSearch /></AdminRoute>} />
<Route path="/Admin-Generation-Matches" element={<AdminRoute><AdminGenerationMatches /></AdminRoute>} />
<Route path="/Admin-Forex-Tracking" element={<AdminRoute><AdminForexTracking /></AdminRoute>} />
<Route path="/Admin-HackingMatches" element={<AdminRoute><AdminHackingMatches /></AdminRoute>} />
<Route path="/Admin-BadilishaMudaWaMatches" element={<AdminRoute><AdminBadilishaMudaWaMatches /></AdminRoute>} />
<Route path="/admin/add-match" element={<AdminRoute><AddMatch /></AdminRoute>} />
<Route path="/admin/admin-users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
<Route path="/admin/bonus-member" element={<AdminRoute><BonusMember /></AdminRoute>} />
<Route path="/admin/admin-securitywithdraw" element={<AdminRoute><AdminSecurityWithdraw /></AdminRoute>} />
<Route path="/adminadd-icehockey" element={<AdminRoute><AdminAddIceHockey /></AdminRoute>} />
<Route path="/Admin-transactions" element={<AdminRoute><AdminTransactions /></AdminRoute>} />
<Route path="/Admin-AddFinalScore" element={<AdminRoute><AdminAddFinalScore /></AdminRoute>} />
<Route path="/Admin-BonusManager" element={<AdminRoute><AdminBonusManager /></AdminRoute>} />
<Route path="/Admin-VistorDeposit" element={<AdminRoute><AdminVistorDeposit /></AdminRoute>} />
<Route path="/Admin-MonthlyBonus" element={<AdminRoute><AdminMonthlyBonus /></AdminRoute>} />
<Route path="/admin-betspayoutlost" element={<AdminRoute><AdminBetsPayoutLost /></AdminRoute>} />
<Route path="/admin-usersmember" element={<AdminRoute><AdminUsersMember /></AdminRoute>} />
<Route path="/Admin-Notifications" element={<AdminRoute><AdminNotifications /></AdminRoute>} />
<Route path="/Admin-DuplicateMatches" element={<AdminRoute><AdminDuplicateMatches /></AdminRoute>} />
<Route path="/edit-match/1" element={<AdminRoute><EditMatch /></AdminRoute>} />
<Route path="/admin-matchmanager" element={<AdminRoute><AdminMatchManager /></AdminRoute>} />
<Route path="/admin-historiayadau" element={<AdminRoute><AdminHistoriayadau /></AdminRoute>} />
<Route path="/admin-managenumbers" element={<AdminRoute><AdminManageNumbers /></AdminRoute>} />
<Route path="/admin-commissions" element={<AdminRoute><AdminCommissions /></AdminRoute>} />
<Route path="/Admin-BetsRequest" element={<AdminRoute><AdminBetsRequest /></AdminRoute>} />
<Route path="/Admin-CommissionHistory" element={<AdminRoute><AdminCommissionHistory /></AdminRoute>} />
<Route path="/admin-deletedwithdrawhistory" element={<AdminRoute><AdminDeletedWithdrawHistory /></AdminRoute>} />
<Route path="/Futa-Maombi-Ya-Uondoaji" element={<AdminRoute><FutaMaombiYaUondoaji /></AdminRoute>} />
<Route path="/postertemplate" element={<AdminRoute><PosterTemplate /></AdminRoute>} />
<Route path="/admin/pending-withdrawals" element={<AdminRoute><PendingWithdrawals /></AdminRoute>} />
<Route path="/admin-usersearch" element={<AdminRoute><AdminUserSearch /></AdminRoute>} />
<Route path="/Admin-Usdt-Transaction" element={<AdminRoute><AdminUsdtTransaction /></AdminRoute>} />
<Route path="/admin-exchanges" element={<AdminRoute><AdminExchanges /></AdminRoute>} />
<Route path="/admin-balance-control" element={<AdminRoute><AdminBalanceControl /></AdminRoute>} />
<Route path="/admin-cheki-bonus" element={<AdminRoute><Adminchekibonus /></AdminRoute>} />
<Route path="/admin.futa.group" element={<AdminRoute><Adminfutagroup /></AdminRoute>} />
<Route path="/AdminSearchUser" element={<AdminRoute><AdminSearchUser /></AdminRoute>} />
<Route path="/AdminVolatility-ForexTransaction" element={<AdminRoute><AdminVolatilityForexTransaction /></AdminRoute>} />
<Route path="/adminadd-basketball" element={<AdminRoute><AdminAddBasketball /></AdminRoute>} />
<Route path="/adminadd-tabletennes" element={<AdminRoute><AdminAddTabletennes /></AdminRoute>} />
<Route path="/adminadd-baseball" element={<AdminRoute><AdminAddBaseball /></AdminRoute>} />
<Route path="/admin-volatility" element={<AdminRoute><AdminVolatility /></AdminRoute>} />
<Route path="/Admin-Add-Copy-Trading" element={<AdminRoute><AdminAddCopyTrading/></AdminRoute>} />
<Route path="/Admin-Copy-Trading-Request" element={<AdminRoute><AdminCopyTradingRequest/></AdminRoute>} />
<Route path="/Admin-View-Withdra-wHistory" element={<AdminRoute><AdminViewWithdrawHistory/></AdminRoute>} />
<Route path="/Admin-Ediot-Transaction" element={<AdminRoute><AdminEdiotTransaction/></AdminRoute>} />




{/* ================= AGENT ROUTES ================= */}

<Route path="/agent-dashboard" element={<AgentRoute><AgentDashboard /></AgentRoute>} />
<Route path="/agent-historiayadau" element={<AgentRoute><AgentHistoriayadau /></AgentRoute>} />
<Route path="/agent-DuplicateMatches" element={<AgentRoute><AgentDuplicateMatches /></AgentRoute>} />

<Route path="/agent-pending" element={<PrivateRoute><AgentPending /></PrivateRoute>} />
<Route path="/agent-add-matches" element={<PrivateRoute><AgentAddMatches /></PrivateRoute>} />
<Route path="/agent-search-user" element={<PrivateRoute><AgentSearchUser /></PrivateRoute>} />





<Route
              path="*"
              element={<Navigate to="/login" replace />}
            />

          </Routes>
        </LayoutWithBottomNav>
      </Router>

      </BalanceProvider>
    </LanguageContext.Provider>
  );
};

export default App;